/* hs-winder-match.js — gedeelde matchlogica Horlogerieshop.nl
   Spiegelt winders_match.py. Matchregel:
   - winder moet de vereiste TPD kunnen leveren in de vereiste richting (geen ondershoot)
   - overshoot 0-200 = geschikt (A) — dankzij de slipkoppeling niet schadelijk
   - overshoot > 200 = alternatief (B) — draait onnodig ver boven de gevraagde waarde
   Sortering: best verkocht eerst (veld r uit hs-winder-data.js).                */
window.HS_WINDER_MATCH = (function () {
  var MARGIN = 200;

  function ceilIn(t, req) {
    if (t.kind === 'range') {
      if (req > t.max) return null;
      return Math.max(req, t.min);
    }
    if (t.kind === 'step') {
      if (req > t.max) return null;
      var base = Math.max(req, t.min);
      var k = Math.ceil((base - t.min) / t.step);
      var v = t.min + k * t.step;
      return v <= t.max ? v : null;
    }
    if (t.kind === 'set') {
      var best = null;
      for (var i = 0; i < t.values.length; i++) {
        var s = t.values[i];
        if (s >= req && (best === null || s < best)) best = s;
      }
      return best;
    }
    return null;
  }

  /* -> {grade:'A'|'B', overshoot, setting} of null (niet geschikt) */
  function classify(w, reqTpd, reqDir) {
    var best = null;
    for (var i = 0; i < w.caps.length; i++) {
      var c = w.caps[i];
      if (c.dirs.indexOf(reqDir) === -1) continue;
      var v = ceilIn(c.tpd, reqTpd);
      if (v === null) continue;
      var o = v - reqTpd;
      if (best === null || o < best.overshoot) best = { overshoot: o, setting: v };
    }
    if (!best) return null;
    best.grade = best.overshoot <= MARGIN ? 'A' : 'B';
    return best;
  }

  /* filters: {n, maxPrice, vendor, led, storage} — alle optioneel.
     n = EXACT aantal winder-posities (6 = 6 of meer). */
  function passes(w, f) {
    if (!f) return true;
    if (f.maxPrice && w.p > f.maxPrice) return false;
    if (f.n) {
      if (f.n >= 6 ? w.n < 6 : w.n !== f.n) return false;
    }
    if (f.vendor && w.v !== f.vendor) return false;
    if (f.led && !w.led) return false;
    if (f.storage && !(w.s > 0)) return false;
    return true;
  }

  /* alle winders gerangschikt: {a:[{w,overshoot,setting}], b:[...], filtered:bool} */
  function matches(reqTpd, reqDir, filters) {
    var a = [], b = [];
    (window.HS_WINDER_DATA || []).forEach(function (w) {
      if (!passes(w, filters)) return;
      var r = classify(w, reqTpd, reqDir);
      if (!r) return;
      (r.grade === 'A' ? a : b).push({ w: w, overshoot: r.overshoot, setting: r.setting });
    });
    var srt = function (x, y) { return x.w.r - y.w.r; };  // best verkocht eerst
    a.sort(srt);
    b.sort(srt);
    return { a: a, b: b };
  }

  /* richting-string uit de TPD-database -> 'cw'|'ccw'|'bi' */
  function normDir(s) {
    var l = (s || '').toLowerCase();
    if (l.indexOf('counter') > -1 || l.indexOf('ccw') > -1) return 'ccw';
    if (l.indexOf('bi') > -1 || l.indexOf('< >') > -1) return 'bi';
    return 'cw';
  }

  /* Set-matching voor "Mijn horloges": kan deze winder ALLE horloges tegelijk aan?
     watches = [{tpd, dir}].
     - winder heeft minstens zoveel posities als horloges (n >= aantal)
     - per positie instelbaar (pp): elk horloge moet afzonderlijk passen
     - één gedeeld programma (!pp): alle horloges moeten dezelfde richting vragen
       en er moet één TPD-stand zijn die voor allemaal werkt
     A = elke horloge binnen +200 TPD; B = werkt, maar voor minstens één horloge >200 overshoot */
  function classifySet(w, watches) {
    if (w.n < watches.length) return null;
    var settings = [], worst = 0, i, r;
    if (w.pp) {
      for (i = 0; i < watches.length; i++) {
        r = classify(w, watches[i].tpd, watches[i].dir);
        if (!r) return null;
        settings.push(r.setting);
        if (r.overshoot > worst) worst = r.overshoot;
      }
    } else {
      var dir = watches[0].dir, maxReq = 0, minReq = Infinity;
      for (i = 0; i < watches.length; i++) {
        if (watches[i].dir !== dir) return null; // gedeeld programma: 1 richting
        if (watches[i].tpd > maxReq) maxReq = watches[i].tpd;
        if (watches[i].tpd < minReq) minReq = watches[i].tpd;
      }
      r = classify(w, maxReq, dir);
      if (!r) return null;
      for (i = 0; i < watches.length; i++) settings.push(r.setting);
      worst = r.setting - minReq;
    }
    return { grade: worst <= MARGIN ? 'A' : 'B', overshoot: worst, settings: settings };
  }

  function matchesSet(watches, filters) {
    var a = [], b = [];
    (window.HS_WINDER_DATA || []).forEach(function (w) {
      if (!passes(w, filters)) return;
      var r = classifySet(w, watches);
      if (!r) return;
      (r.grade === 'A' ? a : b).push({ w: w, overshoot: r.overshoot, settings: r.settings,
        setting: r.settings.filter(function (v, i, arr) { return arr.indexOf(v) === i; }).join(' / ') });
    });
    var srt = function (x, y) { return x.w.r - y.w.r; };
    a.sort(srt);
    b.sort(srt);
    return { a: a, b: b };
  }

  return { classify: classify, classifySet: classifySet, matches: matches, matchesSet: matchesSet, passes: passes, normDir: normDir, MARGIN: MARGIN };
})();
